import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { PropType } from "vue";
import {
  PositiveCheckmark,
  NegativeCross,
  NegativeAlert,
  NeutralInformation,
  OperationIcon,
  BlockOperation,
} from "tir-style-system/icons/solid";
type StatusVariants = "positive" | "negative" | "alert" | "info" | "operation" | "blocking";


export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-status-budge',
  props: {
  /**
   * Размер
   */
  size: {
    type: String as PropType<"xxxl" | "xxl" | "xl" | "l" | "m">,
    default: "xl",
  },
  /**
   *  Цвет иконки
   */
  statusColor: {
    type: String as unknown as PropType<
      | StatusVariants
      | "positive-invert"
      | "negative-invert"
      | "alert-invert"
      | "info-invert"
      | "operation-invert"
      | "blocking-invert"
      | "neutral-invert"
    >,
    default: "positive",
  },
  /**
   *  Иконка и цвет
   */
  statusIconType: {
    type: String as PropType<StatusVariants>,
    default: "positive",
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["status-budge", {
      'status-budge--xxxl': props.size == 'xxxl',
      'status-budge--xxl': props.size == 'xxl',
      'status-budge--xl': props.size == 'xl',
      'status-budge--l': props.size == 'l',
      'status-budge--m': props.size == 'm',
      'status-budge--color-positive': props.statusColor == 'positive',
      'status-budge--color-negative': props.statusColor == 'negative',
      'status-budge--color-alert': props.statusColor == 'alert',
      'status-budge--color-info': props.statusColor == 'info',
      'status-budge--color-operation': props.statusColor == 'operation',
      'status-budge--color-blocking': props.statusColor == 'blocking',
      'status-budge--color-positive-invert': props.statusColor == 'positive-invert',
      'status-budge--color-negative-invert': props.statusColor == 'negative-invert',
      'status-budge--color-alert-invert': props.statusColor == 'alert-invert',
      'status-budge--color-info-invert': props.statusColor == 'info-invert',
      'status-budge--color-operation-invert': props.statusColor == 'operation-invert',
      'status-budge--color-blocking-invert': props.statusColor == 'blocking-invert',
    }])
  }, [
    (props.statusIconType == 'positive')
      ? (_openBlock(), _createBlock(_unref(PositiveCheckmark), { key: 0 }))
      : _createCommentVNode("", true),
    (props.statusIconType == 'negative')
      ? (_openBlock(), _createBlock(_unref(NegativeCross), { key: 1 }))
      : _createCommentVNode("", true),
    (props.statusIconType == 'alert')
      ? (_openBlock(), _createBlock(_unref(NegativeAlert), { key: 2 }))
      : _createCommentVNode("", true),
    (props.statusIconType == 'info')
      ? (_openBlock(), _createBlock(_unref(NeutralInformation), { key: 3 }))
      : _createCommentVNode("", true),
    (props.statusIconType == 'operation')
      ? (_openBlock(), _createBlock(_unref(OperationIcon), { key: 4 }))
      : _createCommentVNode("", true),
    (props.statusIconType == 'blocking')
      ? (_openBlock(), _createBlock(_unref(BlockOperation), { key: 5 }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})